'use client';

import { useGlossaries } from 'providers/GlossaryProviders/useGlossaries';
import { createContext, FC, PropsWithChildren, useContext } from 'react';

type TGlossaryContext = {
  isChecking: boolean;
  hasGlossary: boolean;
};

const initialState: TGlossaryContext = {
  isChecking: true,
  hasGlossary: true
};

const GlossaryContext = createContext<TGlossaryContext>(initialState);

const useGlossaryContext = (): TGlossaryContext => useContext(GlossaryContext);

const GlossaryProvider: FC<PropsWithChildren<unknown>> = ({ children }): JSX.Element => {
  const { data, isLoading, isPending } = useGlossaries();

  const isChecking = isLoading || isPending;
  const hasGlossary = !!((data?.glossaries?.nodes?.length ?? 0) > 1);

  return (
    <GlossaryContext.Provider
      value={{
        isChecking,
        hasGlossary
      }}
    >
      {children}
    </GlossaryContext.Provider>
  );
};

export { GlossaryProvider, useGlossaryContext };
